import type {KeyTextField} from '@prismicio/client'
import type {Top10AiToolsSliceDefaultPrimaryDuopolySegmentsItem} from 'prismicio-types'
import React from 'react'

const SEGMENT_COLORS = ['#B4FF44', '#2C8FFF', 'rgba(255,255,255,0.16)']
const SEGMENT_TEXT_COLORS = ['#131212', '#FFFFFF', 'rgba(255,255,255,0.85)']

interface Props {
  title: KeyTextField
  subtitle: KeyTextField
  desc: KeyTextField
  segments: Top10AiToolsSliceDefaultPrimaryDuopolySegmentsItem[]
}

const DuopolyBar: React.FC<Props> = ({title, subtitle, desc, segments}) => (
  <section style={{maxWidth: 1180, margin: '0 auto', padding: '96px 32px'}}>
    <div className="t10-duopoly">
      <div className="t10-duopoly-head">
        {title && <h2 className="t10-duopoly-title">{title}</h2>}
        {subtitle && <p className="t10-duopoly-sub">{subtitle}</p>}
      </div>
      {desc && <p className="t10-duopoly-desc">{desc}</p>}

      {segments && segments.length > 0 && (
        <div className="t10-duopoly-bar">
          {segments.map((seg, i) => {
            const pct = parseFloat(String(seg.segment_pct ?? '0')) || 0
            return (
              <div
                key={i}
                className="t10-duopoly-seg"
                style={{
                  flex: `${pct} 0 0%`,
                  background: SEGMENT_COLORS[i] ?? 'rgba(255,255,255,0.16)',
                  color: SEGMENT_TEXT_COLORS[i] ?? 'rgba(255,255,255,0.85)',
                }}
              >
                <span className="t10-duopoly-seg-label">{seg.segment_label}</span>
                <span className="t10-duopoly-seg-val">{seg.segment_pct}</span>
              </div>
            )
          })}
        </div>
      )}
    </div>
  </section>
)

export default DuopolyBar
